import { render, staticRenderFns } from "./userPortrait.vue?vue&type=template&id=28a5022f&scoped=true"
import script from "./userPortrait.vue?vue&type=script&lang=js"
export * from "./userPortrait.vue?vue&type=script&lang=js"
import style0 from "./userPortrait.vue?vue&type=style&index=0&id=28a5022f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a5022f",
  null
  
)

export default component.exports